import type { RootState } from "@/app/store";

export const selectCrime = (state: RootState) => state.crime;
export const selectNextCrimeTime = (state: RootState) => state.crime.nextCrimeTime;
export const selectIsMakingCrime = (state: RootState) => state.crime.isMakingCrime;
export const selectMyCrimeType = (state: RootState) => state.crime.myCrimeType;
